<template>
  <Layout>
    <div style="width: 100%">
      <div class="index-page">
        <div data-am-widget="tabs" class="am-tabs am-tabs-default">
          <div class="am-tabs-bd">
            <div
                class="am-tab-panel am-active"
                v-if="slideshow.length > 0"
                :style="{ backgroundImage: `url(${imageTran(slideshow[tabIndex].imageUrl)})`}">
              <div class="index-banner">
                <div class="index-mask">
                  <div class="container">
                    <div class="am-g">
                      <div class="am-u-md-10 am-u-sm-centered" style="text-align: center">
                        <h1 class="slide_simple--title">{{ slideshowHover.title }}</h1>
                        <p class="slide_simple--text am-text-left" style="display: flex;justify-content: center">
                          {{ slideshowHover.introduction }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <ul class="am-tabs-nav am-cf index-tab">
            <li v-for="(tab,index) in tabList" :key="index" :class="tabIndex === index ? 'am-active':''">
              <a href="#" @click.prevent="changeTab(index)">
                <div class="am-u-md-3 am-u-sm-3 am-padding-right-0">
                  <i :class="tab.icon"></i>
                </div>
                <div class="school-item-right am-u-md-9 am-u-sm-9 am-text-left">
                  <strong class="promo_slider_nav--item_title">{{ tab.name }}</strong>
                  <p class="promo_slider_nav--item_description">{{ tab.desc }}</p>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="section">
      <div class="container" style="max-width: 1160px;">
        <div class="section--header">
          <h2 class="section--title">Core Advantages</h2>
          <p class="section--description">
              With customized services, flexible design capabilities, technological innovation, and high cost-performance, Jicjia Elevators is able to secure a position in the highly competitive market, while meeting the diverse needs of customers, especially excelling in high-end home elevators and personalized customization.
          </p>
        </div>

        <div class="index-container">
          <div class="am-g">
            <div class="am-u-md-3" v-for="(advantage,index) in advantageList" :key="index">
              <div class="features_item">
                <img :src="advantage.cover" alt="">
                <h3 class="features_item--title">{{ advantage.title }}</h3>
                <p class="features_item--text">{{ advantage.desc }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section" style="border-bottom: 1px solid #e9e9e9; padding-top: 0">
      <div class="container" style="max-width: 1160px;">
        <div class="section--header">
          <h2 class="section--title">Our Services</h2>
          <p class="section--description">
              After more than ten years of product development and technology accumulation
            <br>The company has accumulated superb experience in new product development, design, manufacturing and custom processing. And based on the world's excellent home elevator design and technical processing technology, it has established excellent home elevator product research and development and design.
          </p>
        </div>

        <div class="index-container">
          <div class="am-g">
            <div class="am-u-md-3" v-for="(service,index) in serviceList" :key="index">
              <div class="service_item">
                <i class="service_item--icon" :class="service.icon"></i>
                <h3 class="service_item--title">{{ service.title }}</h3>
                <div class="service_item--text"><p>{{ service.desc }}</p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/components/common/Layout";
import {imageTran} from "@/api/http";

export default {
  name: "IndexView",
  components: {Layout},
  data() {
    return {
      tabList: [
        {name: 'Home elevator', desc: 'Summarize the characteristics in one sentence', icon: 'am-icon-cog'},
        {name: 'Villa elevator', desc: 'Summarize the characteristics in one sentence', icon: 'am-icon-lightbulb-o'},
        {name: 'Sightseeing elevator', desc: 'Summarize the characteristics in one sentence', icon: 'am-icon-line-chart'},
        {name: 'About Us', desc: 'Summarize the characteristics in one sentence', icon: 'am-icon-hourglass-end'},
      ],
      tabIndex: 0,
      slideshow: [],
      slideshowHover: {},

      advantageList: [
        {
          id: 1,
          cover: require('../assets/images/index/f01.jpg'),
          title: 'Superior Safety Performance',
          desc: 'Multi-Layered Safety Mechanisms、Emergency Rescue Systems、Compliance with Global Standards'
        },
        {
          id: 2,
          cover: require('../assets/images/index/f01.jpg'),
          title: 'Energy Efficiency & Environmental Sustainability',
          desc: 'Energy Regeneration Systems、Low Noise & Eco-Friendly'
        },
        {
          id: 3,
          cover: require('../assets/images/index/f01.jpg'),
          title: 'Smart Control & Intelligent Upgrades',
          desc: 'AI-Powered Dispatch、IoT Remote Monitoring、User-Centric Interfaces'
        },
        {
          id: 4,
          cover: require('../assets/images/index/f01.jpg'),
          title: 'Space Optimization & High-Speed Performance',
          desc: 'Machine-Room-Less (MRL) Design、High-Speed Operation、Smooth Ride Quality'
        },
      ],
      serviceList: [
        {
          id: 1,
          icon: 'am-icon-diamond',
          title: '多页面工作',
          desc: '标签栏可切换，不必为了新内容而被迫跳转界面，多项工作内容并行处理'
        },
        {
          id: 2,
          icon: 'am-icon-user',
          title: '多页面工作',
          desc: '标签栏可切换，不必为了新内容而被迫跳转界面，多项工作内容并行处理'
        },
        {
          id: 3,
          icon: 'am-icon-umbrella',
          title: '多页面工作',
          desc: '标签栏可切换，不必为了新内容而被迫跳转界面，多项工作内容并行处理'
        },
        {
          id: 4,
          icon: 'am-icon-briefcase',
          title: '多页面工作',
          desc: '标签栏可切换，不必为了新内容而被迫跳转界面，多项工作内容并行处理'
        }
      ]
    }
  },
  mounted() {
    this.getSlideshow()
  },
  methods: {
    imageTran,
    changeTab(index) {
      this.tabIndex = index
      this.slideshowHover = this.slideshow[index]
    },
    getSlideshow() {
      this.getRequest("/slideshow/slideshow").then(resp =>{
      	if (resp){
      		this.slideshow = resp.data.data
          this.slideshowHover = this.slideshow[0]
      	}
      })
      this.slideshowHover = this.slideshow[0]
    }
  },
}
</script>

<style scoped>

</style>
